import { useEffect, useRef } from 'react';
export default function InfiniteScroll({ hasMore, loading, onLoadMore }: { hasMore: boolean; loading: boolean; onLoadMore: () => void }) {
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!hasMore || loading || !ref.current || typeof IntersectionObserver === 'undefined') return;
        const observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) onLoadMore(); }, { rootMargin: '180px' });
        observer.observe(ref.current); return () => observer.disconnect();
    }, [hasMore, loading, onLoadMore]);
    return <div ref={ref} className="py-4 text-center text-xs text-slate-500" role="status">{loading ? 'Carregando registros...' : hasMore ? 'Role para carregar mais' : 'Todos os registros carregados'}</div>;
}
